import { useQuery } from "@tanstack/react-query";
import http_payroll from "../../utils/http_payroll";
import { Api_EndPoints } from "../../utils/Api_EndPoints";

const getCountries = async ({ companyCode }) => {
  const data = await http_payroll.get(
    `${Api_EndPoints.GetCountries}?CompanyCode=${companyCode}`
  );
  return data;
};

export const useCountriesQuery = (companyCode) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetCountries],
    queryFn: () => getCountries(companyCode),
  });
};
